import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAmtJI7Y11ylxxWe5ACK474fgATPD5Ekqc",
  authDomain: "medlog-db0fc.firebaseapp.com",
  projectId: "medlog-db0fc",
  storageBucket: "medlog-db0fc.firebasestorage.app",
  messagingSenderId: "719007718517",
  appId: "1:719007718517:web:5095dcc98fe5142aa3ac3c"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);